import QueryString from "query-string";

class SearchService {
  static search = async (
    query: any,
    offset: number = 0,
    amount: number = 10
  ): Promise<any> => {
    const parameters = QueryString.stringify({
      q: query,
      o: offset,
      a: amount,
    });

    const response = await fetch(`/search/json?${parameters}`, {
      method: "GET",
      credentials: "same-origin",
    });

    return response.json();
  };
}

export { SearchService };
